
import React, { useEffect, useState } from 'react';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { isNumber } from "underscore";

const PlusMinusInputWithDebounce = (props) => {
    const { force_default_quantity, disable_validation_check, QtyMult, QtyMin, single_product_inventory, CART_PRODUCT_DATA } = props;
    const { QuantityAction: { Minus, Plus } } = Constants;
    const [tempQuantity, setTempQuantity] = useState(false);
    const [valid_quantity_message, set_valid_quantity_message] = useState(false);

    const setQuantityWithAction = async (action) => {
        async function fetchHere() {
            let QtyMultHere = QtyMult;
            let q = 0;
            if (action === Minus) {
                q = tempQuantity - QtyMultHere
            }
            if (action === Plus) {
                q = tempQuantity + QtyMultHere
            }
            if (q < 1) {
                q = 0;
            }
            if (q > 0) {
                await manageTempQuantity(q);
            }
        }

        fetchHere()
    };
    useEffect(() => {
        async function fetchHere() {
            if (force_default_quantity) {
                setTempQuantity(force_default_quantity);
            }
        }
        fetchHere();
    }, [force_default_quantity]);

    const manageTempQuantity = (valueIn) => {
        valueIn = parseInt(valueIn);
        if (isNaN(valueIn)) {
            valueIn = 0;
        }
        //validateQty(valueIn)
        setTempQuantity(valueIn);
        if (valueIn !== false) {
            if (props.onChange) {
                if (disable_validation_check) {
                    props.onChange(valueIn)
                    return;
                }
                // let d = validateBeforeSendToMainCheckFailing(valueIn);
                let d = System.checkValidQuantity(CART_PRODUCT_DATA, single_product_inventory, valueIn)
                set_valid_quantity_message(!d);
                if (d === true) {
                    props.onChange(valueIn)
                }
            }
        }
    }
    // const validateBeforeSendToMainCheckFailing = (valueIn) => {
    //     // if (QtyMin && valueIn < QtyMin) {
    //     //     return false;
    //     // }
    //     // if (QtyMult && valueIn % QtyMult !== 0) {
    //     //     return false;
    //     // }
    //     const checkMinMalt = System.checkValidQuantity(CART_PRODUCT_DATA, single_product_inventory, valueIn)

    //     return checkMinMalt;
    // };

    return (
        <>
            <div className="quantity w-auto clearfix ">
                <div className="quantity-picker">
                    <div className="bs5 input-group flex-nowrap border-0">
                        <span className="bs5 input-group-prepend flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction(Minus);
                                }}
                                className="bs5 btn btn-outline-secondary btn-number br-0">
                                <span className="fa quantity-picker-minus" />
                            </button>
                        </span>
                        <input type="text" className="form-control input-number bg-white"
                            placeholder={QtyMult ? QtyMult : 0}
                            value={tempQuantity}
                            onChange={(e) => {
                                let n = parseInt(e.target.value);
                                if (!isNumber(n)) {
                                    n = false;
                                }
                                if (n) {
                                    manageTempQuantity(n)
                                }
                            }}
                        />
                        <span className="bs5 input-group-append flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction(Plus);
                                }}
                                className="bs5 btn btn-outline-secondary btn-number bl-0">
                                <span className="fa quantity-picker-plus" />
                            </button>
                        </span>
                    </div>
                </div>
                {valid_quantity_message === true &&
                    <span className="mandatory">Invalid Quantity</span>
                }
            </div>
        </>
    );
}

export default PlusMinusInputWithDebounce;